import { render, staticRenderFns } from "./NavbarSinav.vue?vue&type=template&id=68f11a36&"
import script from "./NavbarSinav.vue?vue&type=script&lang=js&"
export * from "./NavbarSinav.vue?vue&type=script&lang=js&"
import style0 from "./NavbarSinav.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports